// @flow
import React, { Fragment } from 'react';
import BrandCard from 'components/common/BrandCard';
import type { BrandItem } from 'store/modules/branding';
import FakeBrandCard from 'components/common/FakeBrandCard';
import './BrandCardList.scss';

type Props = {
  brands?: ?(BrandItem[]),
  loading: boolean,
  prefetching: boolean,
  width?: number,
  hasEnded: boolean,
  oneColumn?: boolean,
  placeholderCount?: number,
  isTrending?: boolean,
};

const createArray = length => Array.from(Array(length).keys());
const getColumnCount = width => {
  const xWide = 1920;
  const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 1;

  if (width < medium) return 2; // 모바일: 2개
  if (width < large) return 3; // 태블릿: 3개
  if (width < xLarge) return 4; // 작은 데스크톱: 4개
  if (width < wide) return 5; // 일반 데스크톱: 5개
  if (width < xWide) return 5; // 큰 데스크톱: 5개
  return 5; // 초대형: 5개
};

const getTrendingCount = width => {
  // const xWide = 1920;
  // const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 16;

  if (width < medium) return 16;
  if (width <= large) return 10;
  if (width <= xLarge) return 16;
  // if (width <= wide) return 16;
  // if (width <= xWide) return 20;
  return 20;
};

const BrandCardList = ({
  brands,
  loading,
  prefetching,
  width,
  hasEnded,
  oneColumn,
  isTrending,
}: Props) => {
  const trendingCount = getTrendingCount(width);
  
  if (loading) {
    return (
      <div className="BrandCardList">
        <div className="brand-list-header">
          <div className="loading-skeleton">
            <div className="skeleton-title"></div>
            <div className="skeleton-subtitle"></div>
          </div>
        </div>
        <div className="brand-grid">
          {createArray(trendingCount).map(num => (
            <FakeBrandCard key={num} oneColumn={oneColumn} />
          ))}
        </div>
      </div>
    );
  }

  const columnCount = oneColumn ? 1 : getColumnCount(width);
  if (!brands) return null;
  
  const TrendingList = isTrending ? brands.slice(0, trendingCount) : brands;
  const brandList = (hasEnded || brands.length <= 20
    ? TrendingList
    : brands.slice(0, brands.length - (brands.length % columnCount))
  ).map(brand => (
    <BrandCard
      key={brand.id}
      id={brand.id}
      thumbnail={brand.thumbnail}
      title={brand.title}
      body={brand.meta && brand.meta.short_description}
      brandUrl={brand.title}
      urlSlug={brand.url_slug}
      oneColumn={oneColumn}
    />
  ));

  return (
    <div className="BrandCardList">
      {!oneColumn && (
        <div className="brand-list-header">
          <h2 className="brand-list-title">
            <span className="title-icon" role="img" aria-label="브랜드">🏢</span>
            판매 브랜드
          </h2>
          <p className="brand-list-subtitle">
            다양한 브랜드의 제품을 만나보세요
          </p>
        </div>
      )}
      
      <div className={`brand-grid ${oneColumn ? 'one-column' : ''}`}>
        {brandList && brandList.length === 0 && (
          <div className="empty-state">
            <span className="empty-icon" role="img" aria-label="빈 상태">📦</span>
            <h3 className="empty-title">등록된 브랜드가 없습니다</h3>
            <p className="empty-description">새로운 브랜드가 곧 추가될 예정입니다.</p>
          </div>
        )}
        {brandList}
        {prefetching &&
          createArray(columnCount).map(num => <FakeBrandCard key={num} oneColumn={oneColumn} />)}
      </div>
    </div>
  );
};

BrandCardList.defaultProps = {
  brands: [],
  oneColumn: false,
  width: 0,
  placeholderCount: 24,
};

export default BrandCardList;



// WEBPACK FOOTER //
// ./src/components/common/BrandCardList/BrandCardList.js